import DataMigrationBaseInfo from "./dataMigrationBaseInfo";
import V from "./checkStringValidation";

export default class AccountDataMigration extends DataMigrationBaseInfo {


    /**
     * keyName : [[clear 정보], [rule 정보]]
     * strLen rule 을 가질때는 세번째 인자로 글자수를 1개 넣어준다.
     * matchStrLen 을 가질때는 세번째 인자로 매칭할 글자수를 여러개 넣어준다.
     * cms, tax rule은  배열의 맨 마지막에 넣어주세요.
     */



    _rulesOfclearAndValid = {
        accountName: [[], ['require', 'strLen'], ['100']],
        accountLevel: [[], ['strLen'], ['50']],
        bizType: [[], [ 'strLen','bizTypeCheck'], ['10']],
        businessNo: [['onlyNumber','NoHyphen'], [ 'matchStrLen'], ['10', '6']],
        birthday: [['onlyNumber','NoHyphen'], ['matchStrLen'], ['6', '6']],
        ceoFullname: [['NoSpChar'], ['strLen'], ['50']],
        telNo: [['onlyNumber','NoBlank','NoHyphen'], ['strLen'], ['11']],
        fax: [['onlyNumber','NoBlank'], ['strLen'], ['11']],
        email: [['NoBlank'],['email']],
        chargerFullname: [['NoSpChar'], ['strLen'], ['100']],
        chargerMobileNo: [['onlyNumber','NoBlank'], ['strLen'], ['11']],
        businessType: [[], ['strLen'], ['50']],
        businessKind: [[], ['strLen'], ['50']],
        address: [[], ['strLen'], ['255']],
        addressDetail: [[], ['strLen'], ['255']],
        memo: [[], ['strLen'], ['2000']],
        mainItem: [[], ['strLen'], ['50']],
        contractFeeYn: [[],[]],
        contractFee: [['onlyNumber', 'NoBlank'], ['strLen'], ['10']],
        calculationStartdate: [['onlyNumber', 'NoBlank'], ['strLen'], ['2']],
        billDay: [['onlyNumber','NoBlank'], ['strLen'], ['2']],
        taxSchDay: [['onlyNumber', 'NoBlank'], ['strLen'], ['2']],
        statementIssueDay: [['onlyNumber', 'NoBlank'], ['strLen'], ['2']],
        unpaidRequestYn: [[],[]],
        autoYn: [[],[]],
        itemGroup:  [[], ['strLen','contract'], ['50']], // 품목계약 시작
        modelName:  [[], [ 'strLen','contract'], ['255']], // 품목계약 존재시필수
        baseFee: [['onlyNumber','NoBlank'], ['strLen','contract'], ['9']],
        automaticallyConfirmSales: [[],['contract']],
        automaticallyAdditionalSales: [[],['contract']],
        installLocation: [[], ['strLen','contract'], ['255']],
        startSalesMonth:  [['NoBlank'], ['dateYYYYMMdd','contract']],
        contractStartdate: [['NoBlank'], ['dateYYYYMMdd','contract']],
        contractEnddate: [['NoBlank'], ['dateYYYYMMdd','contract']],
        contractDate: [['NoBlank'], ['dateYYYYMMdd','contract']],
        itemQty: [['onlyNumber'], ['strLen','contract'], ['10']],
        itemPrice: [['onlyNumber'], ['strLen','contract'], ['10']],
        engineCountYn: [[],['contract']],
        a3DoubleCountYn: [[],['contract']],
        colorYn: [[],['contract']],
        basePagecountMono: [['onlyNumber', 'NoBlank'], ['strLen','contract'], ['10']],
        basePagecountColor: [['onlyNumber', 'NoBlank'], ['strLen','contract'], ['10']],
        additionalFeeMono: [['onlyNumber', 'NoBlank'], ['strLen','contract'], ['10']],
        additionalFeeColor: [['onlyNumber', 'NoBlank'], ['strLen','contract'], ['10']],
        deposit: [[], ['strLen','contract'], ['10']],
        contractMemo: [[], ['strLen','contract'], ['2000']],
        accountToTaxYn: [[],['tax']], // 세금계산서 시작
        taxNickname: [[], ['strLen','tax'], ['45']],
        companyName: [[], ['strLen', 'tax'], ['100']],
        taxBizType: [[], ['strLen', 'tax'], ['10']],
        taxBusinessNo: [['onlyNumber','NoBlank','NoHyphen'], ['strLen', 'tax'], ['20']],
        ownerName: [['NoSpChar'], ['strLen','tax'], ['20']],
        taxBusinessType: [[], ['strLen' ,'tax'], ['100']],
        taxBusinessKind: [[], ['strLen','tax'], ['100']],
        chargerName: [['NoSpChar'], ['strLen', 'tax'], ['100']],
        mobileNo: [['onlyNumber'], ['strLen', 'tax'], ['20']],
        taxEmail: [['NoBlank'],['email', 'tax']],
        businessTypeNumber:[['onlyNumber','NoBlank'], ['matchStrLen', 'tax'], ['4']],
        taxAddress: [[], ['strLen', 'tax'], ['100']],
        taxRequestType:  [[], ['strLen', 'tax','taxRequestTypeCheck'], ['10']],
        taxAutoYn: [[],['tax']],
        cmsNickname: [[], ['strLen','cms'], ['45']], // cms 시작
        cmsId: [['onlyNumber'],['cms']],
        csName: [[],['cms']],
        payMethod: [['PaymentMethod'],['cms']],
        bankCd: [['bankCode'], ['cms']],
        accNo: [[], ['strLen','cms'], ['16']],
        cardNo: [['NoHyphen'], ['strLen','cms'], ['16']],
        cardValidDt: [[], ['strLen','cms'], ['4']],
        accBizNo: [['onlyNumber'], ['matchStrLen','cms'], ['10', '6']],
        csHp: [['onlyNumber'], ['strLen','cms'], ['11']],
        csEmail:  [['NoBlank'],['email','cms']],
        cashReptNo:[['onlyNumber', 'NoBlank'],['cms']],
        smsYn:[[],['cms']],
        cmsAutoYn:[[],['cms']],
        registerYn:[[],['cms']]

    }

    _taxRulesOfclearAndValid = {
        accountId: [['onlyNumber'], ['require', 'tax']],
        accountToTaxYn: [[],['tax']],
        taxNickname: [[], ['strLen','tax'], ['45']],
        companyName: [[], ['strLen', 'tax'], ['100']],
        taxBizType: [[], ['strLen', 'tax','taxBizTypeCheck'], ['10']],
        taxBusinessNo: [['onlyNumber','NoBlank','NoHyphen'], ['strLen', 'tax'], ['20']],
        ownerName: [['NoSpChar'], ['strLen','tax'], ['20']],
        taxBusinessType: [[], ['strLen' ,'tax'], ['100']],
        taxBusinessKind: [[], ['strLen','tax'], ['100']],
        chargerName: [['NoSpChar'], ['strLen', 'tax'], ['100']],
        mobileNo: [['onlyNumber'], ['strLen', 'tax'], ['20']],
        taxEmail: [['NoBlank'],['email', 'tax']],
        businessTypeNumber:[['onlyNumber','NoBlank'], ['matchStrLen', 'tax'], ['4']],
        taxAddress: [[], ['strLen', 'tax'], ['100']],
        taxRequestType:  [[], ['strLen', 'tax','taxRequestTypeCheck'], ['10']],
        taxAutoYn: [[],['tax']],
    }

    _contractRulesOfclearAndValid = {
        accountId: [['onlyNumber'], ['require','contract']],
        itemGroup:  [[], ['strLen','contract'], ['50']],
        modelName:  [[], [ 'strLen','contract'], ['255']], // 품목계약 존재시필수
        baseFee: [['onlyNumber','NoBlank'], ['strLen','contract'], ['9']],
        automaticallyConfirmSales: [[],['contract']],
        automaticallyAdditionalSales: [[],['contract']],
        installLocation: [[], ['strLen','contract'], ['255']],
        startSalesMonth:  [['NoBlank'], ['dateYYYYMMdd','contract']],
        contractStartdate: [['NoBlank'], ['dateYYYYMMdd','contract']],
        contractEnddate: [['NoBlank'], ['dateYYYYMMdd','contract']],
        contractDate: [['NoBlank'], ['dateYYYYMMdd','contract']],
        itemQty: [['onlyNumber'], ['strLen','contract'], ['10']],
        itemPrice: [['onlyNumber'], ['strLen','contract'], ['10']],
        engineCountYn: [[],['contract']],
        a3DoubleCountYn: [[],['contract']],
        colorYn: [[],['contract']],
        basePagecountMono: [['onlyNumber', 'NoBlank'], ['strLen','contract'], ['10']],
        basePagecountColor: [['onlyNumber', 'NoBlank'], ['strLen','contract'], ['10']],
        additionalFeeMono: [['onlyNumber', 'NoBlank'], ['strLen','contract'], ['10']],
        additionalFeeColor: [['onlyNumber', 'NoBlank'], ['strLen','contract'], ['10']],
        deposit: [[], ['strLen','contract'], ['10']],
        contractMemo: [[], ['strLen','contract'], ['2000']],
    }


    /**
     * clear, validCheck 외의 key
     */
    _clear = {
        'onlyNumber': V.deleteString,
        'bankCode': V.changeBankCode,
        'PaymentMethod': V.changePaymentMethod,
        'NoBlank': V.deleteBlankSpace,
        'NoSpChar': V.deleteSpecialCharacters,
        'NoHyphen': V.deleteHyphen,
        'cashReptType': V.changeCashReptType
    }

    _validCheck = {
            'require' : { func: V.checkRequired, errMsg: '필수값이 없습니다.' },
            'strLen': { func: V.checkLessThanStringLengh, errMsg: '글자수가 많습니다. 제한 글자수 : ' },
            'matchStrLen': { func: V.checkMatchStringLengh, errMsg: '글자 수가 맞지 않습니다. 지정 글자수 : ' },
            'email': { func: V.checkEmail, errMsg: '이메일 형식이 아닙니다.' },
            'dateYYYYMMdd': { func: V.checkYYYYMMDDDateFormat, errMsg: '날짜 형식이 아닙니다. YYYY-MM-DD 형식으로 작성해주세요.' },
            'cms': { func: '', errMsg: '필수 값이 부족합니다. 납부자 번호, 납부자명, 납부방법, 카드 및 계좌번호를 확인해주세요.  납부방법이 카드인 경우 카드번호, 은행인 경우 계좌번호를 입력해야 합니다.' },
            'tax': { func: '', errMsg: '필수 값이 부족합니다. 상호,거래처 유형,등록번호,대표자명을 확인해주세요.'},
            'contract': { func: '', errMsg: '품목의 필수 값이 부족합니다. 품목명을 확인해주세요.'},
            'checkYN': { func: V.checkYN , errMsg: '필수 값이 부족합니다. 상호, 대표자명, 등록번호를 확인해주세요.'},
            'bizTypeCheck': { func: V.bizTypeCheck , errMsg: '사업자 유형에 개인 또는 사업자로 입력해주세요.'},
            'taxBizTypeCheck': { func: V.bizTypeCheck , errMsg: '거래처 유형에 개인 또는 사업자로 입력해주세요.'},
            'cmsPayTypeCheck': { func: V.cmsPayTypeCheck , errMsg: '납부방법에 은행 또는 카드로 입력해주세요.'},
            'taxRequestTypeCheck': { func: V.taxRequestTypeCheck , errMsg: '청구방식에 청구 또는 영수로 입력해주세요.'},
            'dataCheckMsg': { func: '' , errMsg: '해당 데이터는 정상이나, 동일 거래처의 다른 데이터에 오류내역이 있습니다.'},
     }

    constructor(arr, keys) {
        super(arr, keys)
    }

    dataClearAndValidCheck(items, type){
        let successData = {}
        const failData = {}
        const checkedDataForExcel = {
            s: [],
            f: []
        }
        const tempData = {}


        const checkedData = items.map( (i, idx) => {
            const errMsgs = [];
            const cms = [];
            const tax = [];
            const contract = [];


            this._keysOfEn.map((key, kidx) => {
                const data = i[key]
                // console.log('!!!!!!!!!!! data', data, typeof data)
                let clearData = data;

                // data clear
                if(data){
                    let D = V.dataTrim(data);
                    let clear
                    if(type === 'tax'){
                        clear = this._taxRulesOfclearAndValid[key][0]
                    } else if (type === 'contract'){
                        clear = this._contractRulesOfclearAndValid[key][0]
                    } else{
                        clear = this._rulesOfclearAndValid[key][0];
                    }

                    if(clear.length > 0){
                        clear.map(c => {
                            const clearFunc = this._clear[c];
                            if(c === 'bankCode'){
                                const code = V.deleteString(D)
                                if(code.length > 0){
                                    clearData = code;
                                    i[key] = clearData
                                } else {
                                    clearData = clearFunc(D)
                                    i[key] = clearData
                                }

                            } else if (c === 'PaymentMethod'){
                                if(D === 'B' || D === 'C'){
                                    clearData = D;
                                    i[key] = clearData
                                } else clearData = clearFunc(D)

                            } else {

                                clearData = clearFunc(D)
                                D = clearData
                                i[key] = D
                            }
                        })
                    } else {
                        clearData = D;
                    }
                }

                // data rule
                let rules
                if(type === 'tax'){
                    rules = this._taxRulesOfclearAndValid[key][1]
                } else if (type === 'contract'){
                    rules = this._contractRulesOfclearAndValid[key][1]
                } else{
                    rules = this._rulesOfclearAndValid[key][1];
                }

                rules.map(r => {
                    if(r === 'cms'){
                        if(clearData){
                            cms.push(clearData);
                        }
                    } else if (r === 'tax') {
                        if(clearData){
                            tax.push(clearData);
                        }
                    } else if (r === 'contract') {
                        if(clearData){
                            contract.push(clearData);
                        }
                    }else {
                        const { func, errMsg} = this._validCheck[r];
                        let check = true;
                        let date = '';
                        let dates = [];
                        switch (r) {
                            case 'require':
                                check = func(clearData);
                                break;
                            case 'strLen':
                                if(!clearData) break;
                                date = this._rulesOfclearAndValid[key][2]
                                check = func(clearData, date);
                                break;
                            case 'matchStrLen':
                                if(!clearData) break;
                                dates = this._rulesOfclearAndValid[key][2]
                                check = func(clearData, dates)
                                break;
                            default:
                                if(!clearData) break;
                                check = func(clearData)
                        }

                        if(check === false ){
                            errMsgs.push([this._keyOfkr[kidx], errMsg, date, dates])
                        }
                    }
                })
            })



            // CMS 값이 1개라도 있을 때 필수값이 있는지 체크
            if(cms.length > 0 ){
                if(!i.cmsId || !i.csName || (i.payMethod === 'C' && !i.cardNo)  || (i.payMethod === 'B' && (!i.accNo || !i.bankCd ))){
                    errMsgs.push(['CMS ', this._validCheck['cms'].errMsg, ''])
                }
            }

            // tax 값이 1개라도 있을 때 필수값이 있는지 체크
            if(tax.length > 0){
                if(i.accountToTaxYn != 'Y' && (!i.companyName || !i.taxBizType || !i.taxBusinessNo || !i.ownerName) ){
                    errMsgs.push(['세금계산서 ', this._validCheck['tax'].errMsg, ''])
                }
            }

            // contract 값이 1개라도 있을 때 필수값이 있는지 체크
            if(contract.length > 0){
                if(!i.modelName){
                    errMsgs.push(['계약 ', this._validCheck['contract'].errMsg, ''])
                }
            }

            const finalData = { ...i, errMsgs: errMsgs};



            // 에러메세지가 있으면 실패 데이터로, 없으면 성공데이터로 분기
            // 거래처 이름 단위로 array로 묶음

            let account
            if(type === 'tax'|| type === 'contract'){
                account = i.accountId
            } else {
                account = i.accountName
            }

            if(errMsgs.length > 0){
                if(failData[account]){
                    failData[account].push(finalData)
                } else {
                    failData[account] = [finalData]
                }

                checkedDataForExcel.f.push(finalData)
            } else {
                if(successData[account]){
                    successData[account].push(finalData)
                } else {
                    successData[account] = [finalData]
                }

                checkedDataForExcel.s.push(finalData)
            }




            return finalData
        })



        // 동일 거래처 중 실패내역이 1건이라도 있으면 모두 실패로 보여준다.
        Object.keys(successData).forEach( e =>{
            if( Object.keys(failData).some(d => d === e)){
                successData[e].forEach(item =>{
                    failData[e].push(item)
                })
                delete successData[e]
            }

        })

        checkedDataForExcel.s =  checkedDataForExcel.s.filter(e => {
            if( Object.keys(failData).some(d => d === e.accountName || d === e.accountId)){
                const errMsgs = [];
                errMsgs.push(['거래처', this._validCheck['dataCheckMsg'].errMsg, ''])
                const newData = { ...e , errMsgs: errMsgs}
                checkedDataForExcel.f.push(newData)
                return false
            }else{
                return true
            }

        })



        return { successData, failData, checkedData, checkedDataForExcel}

    }






}